import { Component } from "react";
import { Button, ButtonGroup, Col, Form, InputGroup, Modal, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import axiosInstance from "../../../axiosInstance";
import { MDBIcon, MDBBtn } from 'mdbreact';
import "../../../css/NewTicket.css"
import '@fortawesome/fontawesome-free/css/all.min.css';
import { containsPermission, generateErrorMessage, logOut, make_select_data } from "../../helper";
import { Link } from "react-router-dom";
import AsyncSelect from 'react-select/async'

import Select from 'react-select'
import StbForm from "../../components/StbForm";
import React from "react";

const stb_packages = [
    {
        "value" : 1,
        "label" : "OTT_ძირითადი(12 ლარი)"
    }
]

const internet_packages = [
    {
        "value" : 2,
        "label" : "ინტერნეტი სატესტო"
    }
]


const defaultProviderId = 9;
class NewTicket extends Component {

    constructor(props) {
        super(props);
        this.stb_refs = [];
        this.state = {
            odf_address: "",
            is_create_stb : false,
            is_create_internet : false,
            additional:false,
            types_filters_array: [],
            permissions: [],
            account_id: '',
            provider_id:defaultProviderId,
            stb_packages:stb_packages,
            internet_packages:internet_packages,
            internet_package_id:null,
            first_name: '',
            second_name: '',
            personal_number: '',
            address: '',
            type_id: null,
            phone: '',
            sec_phone: '',
            comment: '',
            city: '',
            stages_filters_array: [],
            stage: null,
            tv_brands: [],
            tv_brand: null,
            internet_speed: null,
            internet_provider: null,
            internet_speeds_array: [],
            internet_providers_array: [],
            problems_array: [],
            selected_problem_id: null,
            quantity: 1,
            odf_name:"",
            odf_id:null,
            errors: {
                account_id: false,
                first_name: false,
                second_name: false,
                city: false,
                personal_number: false,
                stage: false,
                type: false,
                internet_provider: false,
                odf_name:true,
            },
            modal: false,
            error_messages: {
                account_id_error_message: 'გთხოვთ შეიყვანოთ საბილინგო ნომერი',
                first_name_error_message: 'გთხოვთ შეიყვანოთ სახელი',
                second_name_error_message: 'გთხოვთ შეიყვანოთ გვარი',
                phone_error_message: 'გთხოვთ შეიყვანოთ მობილური',
                address_error_message: 'გთხოვთ შეიყვანოთ მისამართი',
                city_error_message: 'გთხოვთ შეიყვანოთ ქალაქი',
                personal_number_error_message: 'გთხოვთ შეიყვანოთ პირადი ნომერი',
                type_select_error_message: 'გთხოვთ აირჩიოთ ტიპი',
                stage_select_error_message: 'გთხოვთ აირჩიოთ მდგომარეობა',
                internet_provider_error_message: 'გთხოვთ აირჩიოთ ინტერნეტ პროვაიდერი',
                odf_name_error_message: 'ინტერნეტის დაყენება შეუძლებელია'
            },
            response: {
                isValid: false,
                isInValid: false,
                message: 'როლი წარმატებით ჩაემატა'
            }
        }
    }
    componentDidMount() {
        this.fetch_filter_types();
        this.fetch_tv_brands();
        this.fetch_internet_speeds();
        this.fetch_internet_providers();
        this.fetch_filter_stages();
        this.fetch_stb_packages();
        this.fetch_internet_packages();
    }

    onChange(event) {
        this.setState(
            {
                [event.target.name]: event.target.value,
                errors: {
                    ...this.state.errors,
                    [event.target.name]: false
                }
            }
        )
    }


    valid() {
        var firstname = (this.state.first_name === '');
        var secondname = (this.state.second_name === '');
        var address = (this.state.address === '');
        var phone = (this.state.address === '');
        var city = (this.state.city === '')
        var personal_number = (this.state.personal_number === '')
        var type = (this.state.type_id === null);
        var stage = (this.state.stage === null);
        if (firstname || secondname || address || phone || personal_number || type) {
            this.setState({
                errors: {
                    first_name: firstname,
                    second_name: secondname,
                    address: address,
                    phone: phone,
                    city: city,
                    personal_number: personal_number,
                    type: type,
                    stage: stage
                },
                error_messages: {
                    ...this.state.error_messages,
                    account_id_error_message: 'გთხოვთ შეიყვანოთ საბილინგო ნომერი'
                }
            })
            return false;
        }
        return true;
    }
    afterInsert(data) {
        this.setState({
            ...this.state,
            modal: true
        })
    }
    sendData() {
        let stbs = this.getStbs();
        let onu = this.getOnu();
        var data = {
            account_id: this.state.account_id,
            first_name: this.state.first_name,
            second_name: this.state.second_name,
            personal_number: this.state.personal_number,
            city: this.state.city,
            address: this.state.address,
            phone: this.state.phone,
            second_phone: this.state.sec_phone,
            tv_brand_id: this.state.tv_brand,
            problem_id: this.state.selected_problem_id,
            type_id: this.state.type_id,
            stage_id: this.state.stage,
            internet_speed_id: this.state.internet_speed ? this.state.internet_speed.value : null,
            internet_provider_id: this.state.internet_provider,
            quantity: this.state.quantity,
            text: this.state.comment,
            provider_id:this.state.provider_id,
            stbs:stbs,
            onu:onu
        }
        if (this.valid()) {
            axiosInstance.post('/tickets', data)
                .then(response => this.setState({
                    modal: true
                }))
                .catch(function (error) {
                    if (error.response?.status == 400 || error.response?.status == 422) {
                        this.on_bad_request(error);
                    }
                });
        }
    }

    getStbs(){
        return this.stb_refs.filter((element) =>{
            return element.current !== null;
        }).map((element)=>{
            return element.current.state
        });
    }
    getOnu(){
        return {
            "odf_id" : this.state.odf_id,
            "odf_name" : this.state.odf_name,
            "internet_package_id" : this.state.internet_package_id
        }
    }
    on_bad_request(error) {
        let message = generateErrorMessage(error.response.data.errors);
        this.setState({
            response: {
                ...this.state.response,
                isInValid: true,
                message: message
            }
        })
    }


    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        this.props.history.push('/login')
    }

    OdfHasFreeSpace(odf_id){
        axiosInstance.get('gpon/odf/'+odf_id+'/has/space')
        .then(response => {
            let data = response.data.data
            console.log(data)
            this.setState({
                odf_id:odf_id,
                odf_name:data.odf_name,
                errors: {
                    ...this.state.errors,
                    odf_name:!data.passes,
                },
            })
        })
        .catch(err => {
            if (err.response.status === 401) {
                logOut(this.props);
            }
            if(err.response.status === 503){

            }
        })
    }

    fetchBillingInfo() {
        if (this.state.account_id === '') {
            this.setState({
                errors: {
                    ...this.state.errors,
                    account_id: true
                }
            })
            return;
        }
        axiosInstance.get("/consumers/" + this.state.account_id)
            .then(response => {
                console.log(response.data.data);
                this.setState({
                    address: response.data.data.address,
                    city: response.data.data.city,
                    first_name: response.data.data.first_name,
                    second_name: response.data.data.second_name,
                    personal_number: response.data.data.personal_number,
                    phone: response.data.data.phone,
                    provider_id:response.data.data.provider_id
                })
            })
            .catch(err => {
                console.log(err)
                if (err.response?.status === 401) {
                    this.logout();
                }
                if (err.response?.status === 404) {
                    this.setState({
                        ...this.state,
                        errors: {
                            ...this.state.errors,
                            account_id: true
                        }
                    })
                }

            })
    }



    on_type_fetch(data) {
        this.setState({
            types_filters_array: data
        })
    }

    fetch_filter_types() {
        axiosInstance.get('tickets/types/auth')
            .then(response => {
                this.setState({
                    types_filters_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })

    }

    fetch_tv_brands() {
        axiosInstance.get('/tv_brands')
            .then(response => {
                this.setState({
                    tv_brands: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }
    fetch_stb_packages(){
        axiosInstance.get('/billing/stb/packages/all')
            .then(response => {
                var array = [];
                response.data.data.forEach(function (element) {
                    array.push({
                        value: element.id,
                        label: element.name
                    })
                });
                this.setState({
                    stb_packages: array
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }
    fetch_internet_packages(){
        axiosInstance.get('/billing/internet/packages/all')
            .then(response => {
                var array = [];
                response.data.data.forEach(function (element) {
                    array.push({
                        value: element.id,
                        label: element.name
                    })
                });
                this.setState({
                    internet_packages: array
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    on_tv_brand_change(e) {
        this.setState({
            tv_brand: e.value
        })
    }


    type_filter_changed(e) {
        let type_id = parseInt(e.value)
        this.setState({
            type_id: type_id
        })
        this.fetch_type(type_id);

    }

    fetch_type(type_id){
        axiosInstance.get('tickets/types/' + type_id)
        .then(response => response.data.data).
        then(data => {
            this.setState({
                is_create_internet : data.is_create_internet,
                is_create_stb : data.is_create_stb
            })
        })
        .catch(err => {

        })
    }

    on_stages_fetch(data) {
        this.setState({
            stages: data
        })
    }

    fetch_filter_stages() {
        axiosInstance.get('tickets/stages/inside/')
            .then(response => {
                this.setState({
                    stages_filters_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_problems() {
        axiosInstance.get('/tickets/problems')
            .then(response => {
                this.setState({
                    problems_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }
    fetch_internet_speeds() {
        axiosInstance.get('/internet_speeds')
            .then(response => {
                let speeds = make_select_data(response.data.data);
                let value = speeds[0];
                this.setState({
                    internet_speeds_array: speeds,
                    internet_speed: value
                })

            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_internet_providers() {
        axiosInstance.get('/internet_providers')
            .then(response => {
                let providers = make_select_data(response.data.data);
                this.setState({
                    internet_providers_array: providers,
                })

            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    on_stage_change(e) {
        let stage_id = parseInt(e.value)
        this.setState({
            stage: stage_id
        })
    }

    on_problem_change(e) {
        this.setState({
            selected_problem_id: e.value
        })
    }

    modalClose() {
        window.location.reload();
    }


    loadOptions = () => {
        return axiosInstance.get('gpon/odf/like/address?address=' + this.state.odf_address)
            .then(response => {
                console.log(response.data.data.data)
                return response.data.data.data
            })
            .then(data => data.map(function(element){
                console.log(element);
                return {
                    'label' : element.address,
                    'value' : element.id
                }
            }))
            .catch(error => {
                console.log(error)
            })
    };

    render_stb_forms(){
        return Array(parseInt(this.state.quantity)).fill(null).map((_,index) => {
            let reference = React.createRef();
            this.stb_refs.push(reference)
            return <StbForm
                        exists = {false}
                        isEditable = {true}
                        key={index + 1}
                        index = {index + 1} 
                        stb_packages = {this.state.stb_packages} 
                        tv_brands = {this.state.tv_brands}
                        ref = {reference}
                    />
            }
        );
        
    }

    render() {
        return (
            <div className="new-ticket-container">
                <div className="user-info-container">
                <Form.Row>
                        <Form.Group as={Col} md="2" >
                            <ToggleButtonGroup type="checkbox" value={this.state.provider_id} onChange={(e,d) => {
                                this.setState({
                                    provider_id:d.target.value
                                })
                            }}>
                                {this.state.provider_id == 9 ? <ToggleButton id="tbg-btn-1" value={9}>OTT</ToggleButton> : <ToggleButton variant="secondary" id="tbg-btn-1" value={9}>OTT</ToggleButton>}
                                {this.state.provider_id == 10 ? <ToggleButton  id="tbg-btn-2" value={10}>MARTV</ToggleButton> : <ToggleButton variant="secondary" id="tbg-btn-2" value={10}>MARTV</ToggleButton>}
                                
                            </ToggleButtonGroup>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="4" >
                            <Form.Control
                                type="text"
                                name="role"
                                hidden={true}
                                isInvalid={Boolean(this.state.response.isInValid)}
                                isValid={Boolean(this.state.response.isValid)}
                                onChange={null}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row >
                        <Form.Group as={Col} md="4" controlId="validationFormik03">
                            <Form.Label>საბილინგო ნომერი</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="account_id"
                                    onChange={(event) => this.onChange(event)}
                                    isInvalid={Boolean(this.state.errors.account_id)}
                                    value={this.state.account_id}   
                                />
                                <InputGroup.Prepend>
                                   <Button variant="success" onClick = {(e) => this.fetchBillingInfo(e)}><i className="fas fa-check"></i></Button>
                                </InputGroup.Prepend>

                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationFormik01">
                            <Form.Label>სახელი</Form.Label>
                            <Form.Control
                                type="text"
                                name="first_name"
                                onChange={(event) => this.onChange(event)}
                                isInvalid={Boolean(this.state.errors.first_name)}
                                value={this.state.first_name}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.first_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationFormik02">
                            <Form.Label>გვარი</Form.Label>
                            <Form.Control
                                type="text"
                                name="second_name"
                                onChange={(event) => this.onChange(event)}
                                isInvalid={Boolean(this.state.errors.second_name)}
                                value={this.state.second_name}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.second_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationFormik02">
                            <Form.Label>პირადი ნომერი</Form.Label>
                            <Form.Control
                                type="number"
                                name="personal_number"
                                onChange={(event) => this.onChange(event)}
                                isInvalid={Boolean(this.state.errors.personal_number)}
                                value={this.state.personal_number}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.personal_number_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationFormik010">
                            <Form.Label>ქალაქი</Form.Label>
                            <Form.Control
                                type="text"
                                name="city"
                                onChange={(event) => this.onChange(event)}
                                isInvalid={Boolean(this.state.errors.city)}
                                value={this.state.city}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.city_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="5" controlId="validationFormik04">
                            <Form.Label>მისამართი</Form.Label>
                            <Form.Control
                                type="text"
                                name="address"
                                onChange={(event) => this.onChange(event)}
                                isInvalid={Boolean(this.state.errors.address)}
                                value={this.state.address}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.address_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="3" controlId="validationFormik03">
                            <Form.Label>მობილური</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="phone"
                                    onChange={(event) => this.onChange(event)}
                                    isInvalid={Boolean(this.state.errors.phone)}
                                    value={this.state.phone}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.phone_error_message}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationFormik03">
                            <Form.Label>მობილური (2)</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="sec_phone"
                                    onChange={(event) => this.onChange(event)}
                                    isInvalid={Boolean(this.state.errors.sec_phone)}
                                    value={this.state.sec_phone}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.sec_phone_error_message}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="validationFormik05">
                            <Form.Label>კომენტარი</Form.Label>
                            <Form.Control
                                type="text"
                                name="comment"
                                onChange={(event) => this.onChange(event)}
                                value={this.state.comment}
                            />
                        </Form.Group>
                    </Form.Row>
                    {this.state.provider_id == 9 && <Form.Row className="mg-btn br-btn">
                        <Form.Group as={Col} md="4" >
                            <Form.Label>ინტერნეტის სიჩქარე</Form.Label>
                            <Select
                                maxMenuHeight={170}
                                menuPlacement = "top"
                                options={this.state.internet_speeds_array} onChange={(e) => {
                                    this.setState({
                                        internet_speed: e
                                    })
                                }} placeholder="აირჩიეთ" />
                        </Form.Group>
                        <Form.Group as={Col} md="4" >
                            <Form.Control
                                type="number"
                                name="sec_phone"
                                onChange={null}
                                hidden={true}
                            />
                            <Form.Label>ინტერნეტ პროვაიდერი</Form.Label>
                            <Select
                                maxMenuHeight={170}
                                menuPlacement = "top"
                                options={this.state.internet_providers_array} onChange={(e) => {
                                    this.setState({
                                        internet_provider: e.value,
                                    })
                                }} placeholder="აირჩიეთ" />
                        </Form.Group>
                    </Form.Row>}
                    <Form.Row >
                        <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                            <Form.Control
                                type="number"
                                name="type"
                                onChange={null}
                                isInvalid={Boolean(this.state.errors.type)}
                                hidden={true}
                            />
                            <Form.Label>ტიპი</Form.Label>
                            <Select 
                                maxMenuHeight={170} 
                                menuPlacement = "top" 
                                options={this.state.types_filters_array} 
                                onChange={(e) => this.type_filter_changed(e)} 
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.type_select_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="2"  >
                            <Form.Label>პრობლემა</Form.Label>
                            <Select
                                options={this.state.problems_array}
                                onChange={(e) => this.on_problem_change(e)}
                                placeholder="აირჩიეთ" />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                            <Form.Control
                                type="number"
                                name="sec_phone"
                                onChange={null}
                                isInvalid={Boolean(this.state.errors.stage)}
                                hidden={true}
                            />
                            <Form.Label>მდგომარეობა</Form.Label>
                            <Select maxMenuHeight={170} menuPlacement = "top" options={this.state.stages_filters_array} onChange={(e) => this.on_stage_change(e)} />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.stage_select_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                     
                    {this.state.is_create_stb && 
                        <Form.Row>
                            <Form.Group as={Col} md="1" >
                                <InputGroup>
                                    <Form.Control
                                        type="number"
                                        name="quantity"
                                        defaultValue={1}
                                        onChange={(event) => this.onChange(event)}
                                    />
                                </InputGroup>
                            </Form.Group>   
                        </Form.Row>
                    }
                    {this.state.is_create_stb &&  this.render_stb_forms()}
                    { this.state.provider_id == 10 && this.state.is_create_internet && <Form.Row className="mg-top br-top">
                        <Form.Group as = {Col} md="12">
                            <Form.Label>INTERNET</Form.Label>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                            <Form.Label>ODF მისამართი</Form.Label>
                            <AsyncSelect
                                loadOptions={this.loadOptions}
                                onInputChange={(e) => {
                                    this.setState({
                                        odf_address: e
                                    })
                                }}
                                onChange = {(e) =>{
                                    this.OdfHasFreeSpace(e.value);
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                            <Form.Label>ODF სახელი</Form.Label>
                            <Form.Control
                                    type="text"
                                    name="odf_name"
                                    isInvalid={Boolean(this.state.errors.odf_name)}
                                    isValid={Boolean(!this.state.errors.odf_name)}
                                    readOnly = {true}
                                    value={this.state.odf_name}
                                />
                        </Form.Group>
                        <Form.Group as={Col} md="4" >
                                    <Form.Label>ჩასართავი პაკეტი</Form.Label>
                                    <Select 
                                        options={this.state.internet_packages} 
                                        onChange={(e) => {
                                           this.setState({
                                               internet_package_id:e.value
                                           })
                                        }} 
                                        placeholder="აირჩიეთ" />
                        </Form.Group>
                    </Form.Row>}
                    <Link to="/dashboard" id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                    <Button className="btn btn-success" size="md" onClick={(event) => this.sendData(event)}>დამატება</Button>
                    <Modal show={this.state.modal} centered>
                        <Modal.Body>
                            მონაცემი წარმატებით ჩაემატა!
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="success" onClick={(event) => this.modalClose(event)} >
                                ok
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default NewTicket